import React from "react";

import { useAuth } from "../providers/auth";

import roles from "../constants/roles";
import Unauthorized from "../components/Unauthorized";
import DashAlert from "../components/Dashboard/DashAlert";
import DashboardNav from "../components/Dashboard/DashboardNav";
import CardsProspect from "../components/Dashboard/CardsProspect";
import CardsManagement from "../components/Dashboard/CardsManagement";

import { Outlet } from "react-router-dom";

const Dashboard = () => {
  const { user } = useAuth();
  const userRole = user.group_id;

  return (
    <div className="d-flex flex-column">
      <div className="header border-bottom border-top-right-radius-8">
        <span>Dashboard</span>
      </div>

      <div className="dashboard__container-chart">
        <DashAlert />

        {userRole == roles.PROSPECTING && <CardsProspect />}
        {userRole == roles.DIRETORIA && <CardsManagement />}
        {userRole == roles.GERENCIA && <CardsManagement />}

        <div className="dashboard__chart">
          <div className="dashboard__chart-nav">
            <DashboardNav />
          </div>

          <div className="dashboard__chart-content">
            <Outlet />
          </div>
        </div>
      </div>
    </div>
  );
}

export default Dashboard;
